import React from "react";

const UdhariActionModal = ({
  drawerOpen,
  setDrawerOpen,
  deleteOpen,
  setDeleteOpen,
  setDeleteId,

  form,
  setForm,
  handleSubmit,
  confirmDelete,
  editing,
}) => {
  const [mobileError, setMobileError] = React.useState("");
  const handleMobileSubmit = () => {
    const mobile = String(form.customerMobile || "");

    if (!mobile.startsWith("91")) {
      setMobileError("Mobile number must start with 91.");
      return;
    }

    if (mobile.length !== 12) {
      setMobileError("Mobile number must be exactly 12 digits.");
      return;
    }

    setMobileError("");
    handleSubmit();
  };
  return (
    <>
      {/* edit model */}
      {drawerOpen && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 montserrat-font-1">
          <div className="bg-white w-full max-w-md rounded-2xl shadow-xl p-6 montserrat-font-1">
            {/* HEADER */}
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold text-gray-800">
                Edit Customer
              </h2>

              <button
                onClick={() => setDrawerOpen(false)}
                className="w-8 h-8 flex items-center justify-center rounded-full border hover:bg-gray-100"
              >
                ✕
              </button>
            </div>

            {/* FORM */}
            <div className="space-y-4">
              {/* Loyalty Points */}
              <div>
                <label className="text-sm text-gray-600">Loyalty Points</label>
                <input
                  type="number"
                  value={form.loyaltyPoints}
                  onChange={(e) =>
                    setForm({ ...form, loyaltyPoints: e.target.value })
                  }
                  className="w-full mt-1 border rounded-lg px-3 py-2 bg-gray-50"
                />
              </div>

              {/* Credit Allowed */}
              <div>
                <label className="text-sm text-gray-600">Credit Allowed</label>

                <div className="flex items-center gap-3 mt-2">
                  {/* TOGGLE */}
                  <button
                    type="button"
                    onClick={() =>
                      setForm({
                        ...form,
                        creditAllowed: form.creditAllowed === "Y" ? "N" : "Y",
                      })
                    }
                    className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
                      form.creditAllowed === "Y"
                        ? "bg-green-500"
                        : "bg-gray-300"
                    }`}
                  >
                    <span
                      className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                        form.creditAllowed === "Y"
                          ? "translate-x-6"
                          : "translate-x-1"
                      }`}
                    />
                  </button>

                  {/* TEXT */}
                  <span className="text-sm font-medium">
                    {form.creditAllowed === "Y" ? "Yes" : "No"}
                  </span>
                </div>
              </div>

              {/* Credit Limit */}
              <div>
                <label className="text-sm text-gray-600">
                  Credit Limit (₹)
                </label>
                <input
                  type="number"
                  value={Number(form.creditLimit || 0).toFixed(2)}
                  onChange={(e) =>
                    setForm({ ...form, creditLimit: e.target.value })
                  }
                  className="w-full mt-1 border rounded-lg px-3 py-2 bg-gray-50"
                />
              </div>
            </div>

            {/* FOOTER */}
            <div className="flex justify-end gap-4 mt-6">
              <button
                onClick={() => setDrawerOpen(false)}
                className="text-white bg-gray-600 px-3 py-1.5 rounded-lg font-medium"
              >
                Cancel
              </button>

              <button
                onClick={handleMobileSubmit}
                className="text-white font-semibold bg-green-500 px-3 py-1.5 rounded-lg"
              >
                Update
              </button>
            </div>
          </div>
        </div>
      )}

      {/* delete model  */}
      {deleteOpen && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 montserrat-font-1">
          <div className="bg-white w-[360px] rounded-xl shadow-lg p-6 montserrat-font-1">
            {/* Title */}
            <h3 className="text-lg font-semibold text-gray-800 mb-2">
              Delete Customer
            </h3>

            {/* Message */}
            <p className="text-sm text-gray-500 mb-5">
              Are you sure you want to delete this customer? This action cannot
              be undone.
            </p>

            {/* Buttons */}
            <div className="flex justify-end gap-3">
              <button
                onClick={() => {
                  setDeleteOpen(false);
                  setDeleteId(null);
                }}
                className="px-4 py-2 rounded-lg border bg-gray-100 hover:bg-gray-200 text-sm"
              >
                Cancel
              </button>

              <button
                onClick={confirmDelete}
                className="px-4 py-2 rounded-lg bg-red-500 hover:bg-red-600 text-white text-sm"
              >
                Confirm Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {drawerOpen && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center montserrat-font-1 justify-center z-50">
          <div className="bg-white w-[560px] rounded-2xl shadow-2xl p-6 montserrat-font-1 animate-scaleIn">
            {/* HEADER */}
            <div className="flex justify-between items-center mb-6">
              <div>
                <h2 className="text-xl font-semibold text-gray-800">
                  {editing ? "Edit Customer" : "Add Customer"}
                </h2>
                <p className="text-sm text-gray-500">
                  Manage customer credit & details
                </p>
              </div>

              <button
                onClick={() => setDrawerOpen(false)}
                className="w-9 h-9 flex items-center justify-center rounded-full border hover:bg-gray-100"
              >
                ✕
              </button>
            </div>

            {/* FORM */}
            <div className="grid grid-cols-2 gap-5">
              {/* Customer Name */}
              <div>
                <label className="text-sm text-gray-600">Customer Name</label>
                <input
                  type="text"
                  value={form.customerName}
                  onChange={(e) =>
                    setForm({ ...form, customerName: e.target.value })
                  }
                  className="w-full mt-1 border rounded-xl px-3 py-2.5 focus:ring-2 focus:ring-green-400 outline-none"
                  placeholder="Enter name"
                />
              </div>

              {/* Mobile */}
              {/* Mobile */}
              <div>
                <label className="text-sm text-gray-600">Mobile</label>

                <input
                  type="text"
                  inputMode="numeric"
                  maxLength={12}
                  value={form.customerMobile || ""}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");

                    // Allow maximum 12 digits
                    if (value.length > 12) return;

                    setForm({
                      ...form,
                      customerMobile: value,
                    });

                    // Validation
                    if (value.length > 0 && !value.startsWith("91")) {
                      setMobileError("Mobile number must start with 91.");
                    } else if (value.length === 12) {
                      setMobileError("");
                    } else {
                      setMobileError("");
                    }
                  }}
                  className={`w-full mt-1 border rounded-xl px-3 py-2.5 focus:ring-2 outline-none ${
                    mobileError
                      ? "border-red-500 focus:ring-red-400"
                      : "focus:ring-green-400"
                  }`}
                  placeholder="91XXXXXXXXXX"
                />

                {mobileError && (
                  <p className="mt-1 text-xs text-red-500">{mobileError}</p>
                )}

                {!mobileError &&
                  form.customerMobile &&
                  form.customerMobile.length < 12 && (
                    <p className="mt-1 text-xs text-gray-500">
                      Enter a 12-digit number starting with 91.
                    </p>
                  )}
              </div>

              {/* Credit Limit */}
              <div>
                <label className="text-sm text-gray-600">
                  Credit Limit (₹)
                </label>
                <input
                  type="number"
                  value={form.creditLimit}
                  onChange={(e) =>
                    setForm({ ...form, creditLimit: e.target.value })
                  }
                  className="w-full mt-1 border rounded-xl px-3 py-2.5 focus:ring-2 focus:ring-green-400 outline-none"
                />
              </div>

              {/* Loyalty Points */}
              <div>
                <label className="text-sm text-gray-600">Loyalty Points</label>
                <input
                  type="number"
                  value={form.loyaltyPoints}
                  onChange={(e) =>
                    setForm({ ...form, loyaltyPoints: e.target.value })
                  }
                  className="w-full mt-1 border rounded-xl px-3 py-2.5 focus:ring-2 focus:ring-green-400 outline-none"
                />
              </div>

              {/* Remarks - FULL WIDTH */}
              <div className="col-span-2">
                <label className="text-sm text-gray-600">Remarks</label>
                <textarea
                  value={form.remarks}
                  onChange={(e) =>
                    setForm({ ...form, remarks: e.target.value })
                  }
                  className="w-full mt-1 border rounded-xl px-3 py-2.5 focus:ring-2 focus:ring-green-400 outline-none"
                  rows={2}
                  placeholder="Optional notes..."
                />
              </div>

              {/* CREDIT TOGGLE */}
              <div className="col-span-2 flex items-center justify-between bg-gray-50 px-4 py-3 rounded-xl border">
                <div>
                  <p className="text-sm font-medium text-gray-700">
                    Credit Allowed
                  </p>
                  <p className="text-xs text-gray-500">
                    Enable or disable udhaari for this customer
                  </p>
                </div>

                <button
                  type="button"
                  onClick={() =>
                    setForm({
                      ...form,
                      creditAllowed: form.creditAllowed === "Y" ? "N" : "Y",
                    })
                  }
                  className={`relative inline-flex h-7 w-12 items-center rounded-full transition ${
                    form.creditAllowed === "Y" ? "bg-green-500" : "bg-gray-300"
                  }`}
                >
                  <span
                    className={`inline-block h-5 w-5 transform rounded-full bg-white transition ${
                      form.creditAllowed === "Y"
                        ? "translate-x-6"
                        : "translate-x-1"
                    }`}
                  />
                </button>
              </div>
            </div>

            {/* FOOTER */}
            <div className="flex justify-end gap-3 mt-7">
              <button
                onClick={() => setDrawerOpen(false)}
                className="px-4 py-2 rounded-lg border hover:bg-gray-100"
              >
                Cancel
              </button>

              <button
                onClick={handleSubmit}
                className="px-5 py-2 rounded-lg bg-green-500 hover:bg-green-600 text-white font-medium"
              >
                {editing ? "Update Customer" : "Save Customer"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UdhariActionModal;
